(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4151],{

/***/ 61825:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pelatihan-mandiri/quiz/[id]",
      function () {
        return __webpack_require__(32156);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 44313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_ConfirmNavigateAwayDialog; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@wartek-id/dialog/dist/index.esm.js + 1 modules
var index_esm = __webpack_require__(25929);
// EXTERNAL MODULE: ./node_modules/@wartek-id/text/dist/index.esm.js + 1 modules
var dist_index_esm = __webpack_require__(89004);
;// CONCATENATED MODULE: ./assets/icons/questionmark-fill.svg
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgQuestionmarkFill = function SvgQuestionmarkFill(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M12 2.68994C10.0716 2.68994 8.18657 3.26177 6.58319 4.33311C4.97982 5.40446 3.73013 6.9272 2.99218 8.70878C2.25422 10.4904 2.06114 12.4508 2.43735 14.3421C2.81355 16.2334 3.74215 17.9707 5.10571 19.3342C6.46928 20.6978 8.20656 21.6264 10.0979 22.0026C11.9892 22.3788 13.9496 22.1857 15.7312 21.4478C17.5127 20.7098 19.0355 19.4601 20.1068 17.8568C21.1782 16.2534 21.75 14.3683 21.75 12.4399C21.7471 9.85498 20.7189 7.37673 18.8911 5.54888C17.0632 3.72104 14.585 2.69287 12 2.68994ZM12.0001 18.44C11.7776 18.44 11.56 18.374 11.375 18.2504C11.19 18.1268 11.0458 17.9511 10.9607 17.7455C10.8755 17.5399 10.8533 17.3137 10.8967 17.0955C10.9401 16.8773 11.0472 16.6768 11.2046 16.5195C11.3619 16.3621 11.5624 16.255 11.7806 16.2116C11.9988 16.1682 12.225 16.1905 12.4306 16.2756C12.6361 16.3608 12.8118 16.505 12.9355 16.69C13.0591 16.875 13.1251 17.0925 13.1251 17.315C13.1251 17.6133 13.0065 17.8995 12.7955 18.1105C12.5846 18.3214 12.2984 18.44 12.0001 18.44ZM12.75 13.8564V13.9404C12.75 14.1393 12.671 14.3301 12.5303 14.4707C12.3897 14.6114 12.1989 14.6904 12 14.6904C11.8011 14.6904 11.6103 14.6114 11.4697 14.4707C11.329 14.3301 11.25 14.1393 11.25 13.9404V13.1904C11.25 12.9915 11.329 12.8007 11.4697 12.6601C11.6103 12.5194 11.8011 12.4404 12 12.4404C12.3708 12.4404 12.7334 12.3304 13.0417 12.1244C13.35 11.9184 13.5904 11.6255 13.7323 11.2829C13.8742 10.9403 13.9113 10.5633 13.839 10.1996C13.7666 9.83589 13.5881 9.5018 13.3258 9.23957C13.0636 8.97735 12.7295 8.79877 12.3658 8.72643C12.0021 8.65408 11.6251 8.69121 11.2825 8.83312C10.9399 8.97504 10.647 9.21536 10.441 9.52371C10.235 9.83205 10.125 10.1946 10.125 10.5654C10.125 10.7643 10.046 10.9551 9.90534 11.0957C9.76469 11.2364 9.57392 11.3154 9.37501 11.3154C9.1761 11.3154 8.98533 11.2364 8.84468 11.0957C8.70403 10.9551 8.62501 10.7643 8.62501 10.5654C8.62509 9.93008 8.80449 9.30768 9.14259 8.76979C9.48068 8.2319 9.96373 7.80037 10.5362 7.52481C11.1086 7.24925 11.7472 7.14087 12.3785 7.21213C13.0099 7.28338 13.6082 7.53139 14.1049 7.92761C14.6015 8.32383 14.9762 8.85219 15.1859 9.4519C15.3956 10.0516 15.4317 10.6983 15.2902 11.3177C15.1487 11.9371 14.8352 12.5039 14.3858 12.953C13.9364 13.4021 13.3694 13.7153 12.75 13.8564Z"
  })));
};
/* harmony default export */ var questionmark_fill = (SvgQuestionmarkFill);
;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/components/ConfirmNavigateAwayDialog.tsx





var ConfirmNavigateAwayDialog = function(param) {
    var isOpen = param.isOpen, onClose = param.onClose, onConfirmed = param.onConfirmed, title = param.title, description = param.description, children = param.children, _icon = param.icon, icon = _icon === void 0 ? null : _icon, _confirmText = param.confirmText, confirmText = _confirmText === void 0 ? "Ya" : _confirmText, _cancelText = param.cancelText, cancelText = _cancelText === void 0 ? "Tidak" : _cancelText;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Dialog */.Vq, {
        isOpen: isOpen,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* DialogOverlay */.t9, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* DialogContent */.cZ, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    className: "p-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full mb-6",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center justify-center mx-auto w-14 h-14 rounded-full",
                                children: [
                                    icon === null && /*#__PURE__*/ (0,jsx_runtime.jsx)(questionmark_fill, {
                                        width: 56,
                                        height: 56,
                                        className: "fill-current text-warning"
                                    }),
                                    icon
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mb-2 text-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.x, {
                                as: "span",
                                variant: "heading-sm",
                                children: title
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mb-6 text-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.x, {
                                color: "subdued",
                                children: typeof description === "string" ? description : children
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* DialogCancel */.Ed, {
                            onClick: onClose,
                            className: "block w-full h-[44px] mb-2 leading-[2.75] bg-interactive-default font-bold text-center text-white rounded-lg focus:ring-1 disabled:bg-surface-disabled disabled:text-icon-disabled",
                            children: cancelText
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* DialogAction */.Li, {
                            onClick: onConfirmed,
                            className: "block w-full h-[44px] leading-[2.75] border border-default font-bold focus:ring-1 rounded-lg",
                            children: confirmText
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var components_ConfirmNavigateAwayDialog = (ConfirmNavigateAwayDialog);


/***/ }),

/***/ 32156:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _id_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/query-string/index.js
var query_string = __webpack_require__(68430);
// EXTERNAL MODULE: ./node_modules/@wartek-id/header-bar/dist/index.esm.js + 1 modules
var index_esm = __webpack_require__(89140);
// EXTERNAL MODULE: ./node_modules/@wartek-id/text/dist/index.esm.js + 1 modules
var dist_index_esm = __webpack_require__(89004);
// EXTERNAL MODULE: ./node_modules/@wartek-id/icon/dist/index.esm.js + 1 modules
var icon_dist_index_esm = __webpack_require__(21958);
// EXTERNAL MODULE: ./app/PelatihanMandiriPage/components/QueryNotCompleteError.tsx
var QueryNotCompleteError = __webpack_require__(25536);
// EXTERNAL MODULE: ./components/EmptyState/index.ts + 1 modules
var EmptyState = __webpack_require__(99270);
// EXTERNAL MODULE: ./api/microlearning/useAPIMateri.ts
var useAPIMateri = __webpack_require__(47080);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/@wartek-id/button/dist/index.esm.js + 1 modules
var button_dist_index_esm = __webpack_require__(54204);
// EXTERNAL MODULE: ./app/PelatihanMandiriPage/components/ConfirmNavigateAwayDialog.tsx + 1 modules
var ConfirmNavigateAwayDialog = __webpack_require__(44313);
// EXTERNAL MODULE: ./utils/googleAnalytics.ts
var googleAnalytics = __webpack_require__(7379);
// EXTERNAL MODULE: ./utils/hooks/usePreventRouteChangeIf.ts
var usePreventRouteChangeIf = __webpack_require__(54519);
// EXTERNAL MODULE: ./node_modules/@wartek-id/dialog/dist/index.esm.js + 1 modules
var dialog_dist_index_esm = __webpack_require__(25929);
;// CONCATENATED MODULE: ./assets/icons/checkmark-alt.svg
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgCheckmarkAlt = function SvgCheckmarkAlt(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M2.20825 12.283L8.37492 18.583L23.7916 2.83301",
    stroke: "white",
    strokeWidth: 6.16667
  })));
};
/* harmony default export */ var checkmark_alt = (SvgCheckmarkAlt);
;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/partials/Quiz/QuizDoneDialog.tsx






var QuizDoneDialog = function(param) {
    var isOpen = param.isOpen, onClose = param.onClose, onConfirmed = param.onConfirmed, _canDoRefleksi = param.canDoRefleksi, canDoRefleksi = _canDoRefleksi === void 0 ? false : _canDoRefleksi, _refleksiIsDone = param.refleksiIsDone, refleksiIsDone = _refleksiIsDone === void 0 ? false : _refleksiIsDone;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog_dist_index_esm/* Dialog */.Vq, {
        isOpen: isOpen,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog_dist_index_esm/* DialogOverlay */.t9, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog_dist_index_esm/* DialogContent */.cZ, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    className: "p-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full mb-6",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center justify-center mx-auto w-14 h-14 rounded-full bg-[#4CA375]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(checkmark_alt, {})
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mb-2 text-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.x, {
                                variant: "heading-sm",
                                children: "Selamat! Latihan Pemahaman Selesai"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mb-6 text-center",
                            children: [
                                !canDoRefleksi && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.x, {
                                    children: "Silakan pelajari konten yang ada di aktivitas terlebih dahulu agar Anda dapat mengisi refleksi"
                                }),
                                canDoRefleksi && !refleksiIsDone && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.x, {
                                    children: "Selanjutnya, silakan isi refleksi untuk menyelesaikan materi ini"
                                }),
                                canDoRefleksi && refleksiIsDone && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.x, {
                                    children: "Anda telah menyelesaikan semua aktivitas untuk materi ini. Silakan pilih materi lain untuk dipelajari."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.z, {
                                fullWidth: true,
                                size: "lg",
                                color: refleksiIsDone || !canDoRefleksi ? "black" : "white",
                                onClick: onConfirmed,
                                children: "Kembali ke Materi"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Quiz_QuizDoneDialog = (QuizDoneDialog);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@wartek-id/checkbox/dist/index.esm.js + 1 modules
var checkbox_dist_index_esm = __webpack_require__(78714);
// EXTERNAL MODULE: ./node_modules/@wartek-id/radio/dist/index.esm.js + 1 modules
var radio_dist_index_esm = __webpack_require__(26538);
// EXTERNAL MODULE: ./utils/text.ts + 1 modules
var utils_text = __webpack_require__(40999);
;// CONCATENATED MODULE: ./assets/icons/checkmark-no-fill.svg
var checkmark_no_fill_path;
function checkmark_no_fill_extends() { checkmark_no_fill_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return checkmark_no_fill_extends.apply(this, arguments); }

var SvgCheckmarkNoFill = function SvgCheckmarkNoFill(props) {
  return /*#__PURE__*/react.createElement("svg", checkmark_no_fill_extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), checkmark_no_fill_path || (checkmark_no_fill_path = /*#__PURE__*/react.createElement("path", {
    d: "M3.33325 10.4167L8.33325 15L17.4999 5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
/* harmony default export */ var checkmark_no_fill = (SvgCheckmarkNoFill);
;// CONCATENATED MODULE: ./assets/icons/decline.svg
var decline_path;
function decline_extends() { decline_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return decline_extends.apply(this, arguments); }

var SvgDecline = function SvgDecline(props) {
  return /*#__PURE__*/react.createElement("svg", decline_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), decline_path || (decline_path = /*#__PURE__*/react.createElement("path", {
    d: "M5 5L12 12M19 19L12 12M12 12L19 5L5 19",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
/* harmony default export */ var decline = (SvgDecline);
;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/partials/Quiz/QuestionOptions.tsx










var SingleQuestionOptions = function(param) {
    var options = param.options, page = param.page, onSelected = param.onSelected, _showAnswers = param.showAnswers, showAnswers = _showAnswers === void 0 ? false : _showAnswers;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(null), 2), selected = ref[0], setSelected = ref[1];
    react.useEffect(function() {
        setSelected(null);
    }, [
        page
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(radio_dist_index_esm/* RadioGroup */.Ee, {
        name: "select-answer",
        className: "flex-row -mx-2 flex-wrap mb-6 last:mb-0",
        onChange: function(selectedAnswer) {
            setSelected(selectedAnswer);
            onSelected(selectedAnswer.length > 0, selectedAnswer);
        },
        value: selected,
        children: options.map(function(option, idx) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(radio_dist_index_esm/* Radio */.Y8, {
                className: (0,clsx_m/* default */.Z)("py-4 px-2 w-full rounded-lg", showAnswers && (selected === option.key || option.isCorrect) ? option.isCorrect ? "bg-surface-success-subdued" : "bg-surface-critical-default" : "default"),
                value: option.key,
                checked: option.key === selected,
                style: {
                    maxHeight: "none"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.x, {
                        as: "span",
                        className: "block pr-5",
                        dangerouslySetInnerHTML: {
                            __html: (0,utils_text/* stripHTMLTags */.ox)(option.text)
                        }
                    }),
                    showAnswers && option.isCorrect && /*#__PURE__*/ (0,jsx_runtime.jsx)(checkmark_no_fill, {
                        "data-testid": "answer-correct",
                        className: "absolute top-4 right-2 stroke-current text-icon-success"
                    }),
                    showAnswers && selected === option.key && !option.isCorrect && /*#__PURE__*/ (0,jsx_runtime.jsx)(decline, {
                        "data-testid": "answer-incorrect",
                        className: "absolute top-4 right-2 stroke-current text-icon-critical"
                    })
                ]
            }, option.key + idx);
        })
    });
};
var MultipleQuestionOptions = function(param) {
    var options = param.options, onSelected = param.onSelected, _showAnswers = param.showAnswers, showAnswers = _showAnswers === void 0 ? false : _showAnswers;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState([]), 2), selected = ref[0], setSelected = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_dist_index_esm/* CheckboxGroup */.cO, {
        name: "select-answer",
        className: "flex-row -mx-2 flex-wrap mb-6 last:mb-0",
        onChange: function(selectedAnswer) {
            setSelected(selectedAnswer);
            onSelected(selectedAnswer.length > 0, selectedAnswer);
        },
        value: selected,
        children: options.map(function(option, idx) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(checkbox_dist_index_esm/* Checkbox */.XZ, {
                className: (0,clsx_m/* default */.Z)("relative px-2 py-4 w-full rounded-lg", showAnswers && (selected.includes(option.key) || option.isCorrect) ? option.isCorrect ? "bg-surface-success-subdued" : "bg-surface-critical-default" : "default"),
                value: option.key,
                style: {
                    alignItems: "start"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.x, {
                        as: "span",
                        className: "block pr-5 -mt-0.5",
                        dangerouslySetInnerHTML: {
                            __html: (0,utils_text/* stripHTMLTags */.ox)(option.text)
                        }
                    }),
                    showAnswers && option.isCorrect && /*#__PURE__*/ (0,jsx_runtime.jsx)(checkmark_no_fill, {
                        className: "absolute top-4 right-2 stroke-current text-icon-success"
                    }),
                    showAnswers && selected.includes(option.key) && !option.isCorrect && /*#__PURE__*/ (0,jsx_runtime.jsx)(decline, {
                        className: "absolute top-4 right-2 stroke-current text-icon-critical"
                    })
                ]
            }, option.key + idx);
        })
    });
};

;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/partials/Quiz/QuestionIndicator.tsx





var QuestionIndicator = function(param) {
    var currentIndex = param.currentIndex, totalQuestions = param.totalQuestions;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mb-6",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Text */.x, {
                    variant: "body-sm",
                    color: "default",
                    children: [
                        "Soal ",
                        currentIndex + 1,
                        " dari ",
                        totalQuestions
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex -mx-1 items-center",
                children: (0,_to_consumable_array/* default */.Z)(Array(totalQuestions)).map(function(_, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex-auto px-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,clsx_m/* default */.Z)("h-2 rounded border", i > currentIndex && "border-subdued bg-interactive-disabled", i <= currentIndex && "bg-primary border-primary")
                        })
                    }, i);
                })
            })
        ]
    });
};
/* harmony default export */ var Quiz_QuestionIndicator = (QuestionIndicator);

;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/partials/Quiz/QuizApp.tsx




















var isAnswerCorrect = function(Question, Answer) {
    var selectedOption = Question.answerOptions.find(function(option) {
        return option.key === Answer;
    });
    var ref;
    return (ref = selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.isCorrect) !== null && ref !== void 0 ? ref : false;
};
var QuizApp = function(param) {
    var data = param.data, materialId = param.materialId, _isDesktop = param.isDesktop, isDesktop = _isDesktop === void 0 ? false : _isDesktop;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var ref6 = (0,router.useRouter)(), query = ref6.query, back = ref6.back;
    var ref7 = (0,react.useState)(false), showAnswers = ref7[0], setShowAnswers = ref7[1];
    var ref8 = (0,react.useState)(false), showNavigateAwayDialog = ref8[0], setShowNavigateAwayDialog = ref8[1];
    var ref9 = (0,react.useState)(false), isDone = ref9[0], setIsDone = ref9[1];
    var ref10 = (0,react.useState)([]), answers = ref10[0], setAnswers = ref10[1];
    var ref11 = (0,react.useState)(0), currentIndex = ref11[0], setCurrentIndex = ref11[1];
    var ref12 = (0,react.useState)({
        questionId: null,
        answer: null,
        isCorrect: false
    }), currentAnswer = ref12[0], setCurrentAnswer = ref12[1];
    var contentRef = react.useRef(null);
    (0,react.useEffect)(function() {
        (0,googleAnalytics/* GATrackEvent */.l)({
            eventName: "learning_activity",
            eventParams: {
                event_trigger: "module_open_quiz",
                action_type: "open_material_quiz",
                meta: JSON.stringify({
                    material_id: materialId,
                    module_id: query.modul
                })
            },
            sendDefaultParams: true
        });
    }, [
        materialId,
        query.modul
    ]);
    var ref13 = (0,usePreventRouteChangeIf/* default */.Z)(true, function() {
        setShowNavigateAwayDialog(true);
    }, true), resetPreventRouteChange = ref13.reset;
    var ref14 = (0,useAPIMateri/* usePostQuizProgress */._P)(query.modul, query.id, {
        onSuccess: function() {
            (0,googleAnalytics/* GATrackEvent */.l)({
                eventName: "learning_activity",
                eventParams: {
                    event_trigger: "quiz_complete_quiz",
                    action_type: "complete_material_quiz",
                    meta: JSON.stringify({
                        material_id: materialId,
                        module_id: query.modul
                    })
                },
                sendDefaultParams: true
            });
            setIsDone(true);
        }
    }), mutateAsync = ref14.mutateAsync, isSubmittingForm = ref14.isLoading;
    var gotoNextQuestion = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(questionsCount) {
            var ref;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(questionsCount <= currentIndex + 1)) return [
                            3,
                            2
                        ];
                        resetPreventRouteChange();
                        return [
                            4,
                            mutateAsync({
                                quiz: answers.map(function(answer) {
                                    return typeof answer.answer === "string" ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, answer), {
                                        answer: [
                                            answer.answer
                                        ]
                                    }) : answer;
                                })
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        setCurrentAnswer({
                            questionId: null,
                            answer: null,
                            isCorrect: false
                        });
                        setShowAnswers(false);
                        setCurrentIndex(function(prev) {
                            return prev + 1;
                        });
                        contentRef === null || contentRef === void 0 ? void 0 : (ref = contentRef.current) === null || ref === void 0 ? void 0 : ref.scrollTo(0, 0);
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function gotoNextQuestion(questionsCount) {
            return _ref.apply(this, arguments);
        };
    }();
    var ref15;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("title", {
                    children: [
                        "Pelatihan Mandiri | Latihan Pemahaman materi ",
                        (ref15 = data === null || data === void 0 ? void 0 : data.name) !== null && ref15 !== void 0 ? ref15 : ""
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmNavigateAwayDialog/* default */.Z, {
                isOpen: showNavigateAwayDialog,
                onClose: function() {
                    return setShowNavigateAwayDialog(false);
                },
                onConfirmed: function() {
                    resetPreventRouteChange();
                    back();
                },
                title: "Keluar Dari Latihan Pemahaman?",
                description: "Jika keluar sekarang, progres Latihan Pemahaman tidak akan tersimpan. Tetap keluar?",
                confirmText: "Ya, keluar",
                cancelText: "Lanjut Kerjakan Latihan"
            }),
            !data && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyState/* EmptyState */.ub, {
                    title: "Kuis tidak tersedia",
                    description: "Materi ini tidak memiliki kuis."
                })
            }),
            !!data && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Quiz_QuizDoneDialog, {
                        refleksiIsDone: false,
                        canDoRefleksi: false,
                        isOpen: isDone,
                        onClose: function() {
                            setIsDone(false);
                        },
                        onConfirmed: function() {
                            resetPreventRouteChange();
                            setTimeout(function() {
                                back();
                            }, 50);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: contentRef,
                        className: "py-4 overflow-y-auto ",
                        style: {
                            height: "calc(100vh - ".concat(isDesktop ? 15 : 8.25, "rem)")
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "px-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Quiz_QuestionIndicator, {
                                    currentIndex: currentIndex,
                                    totalQuestions: data === null || data === void 0 ? void 0 : (ref = data.questions) === null || ref === void 0 ? void 0 : ref.length
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mb-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.x, {
                                        as: "div",
                                        color: "default",
                                        variant: "heading-md",
                                        dangerouslySetInnerHTML: {
                                            __html: (ref1 = data === null || data === void 0 ? void 0 : data.questions[currentIndex]) === null || ref1 === void 0 ? void 0 : ref1.text
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (0,clsx_m/* default */.Z)("relative", showAnswers && "before:absolute before:w-full before:h-full before:top-0 before:left-0 before:z-10"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "z-0",
                                        children: [
                                            ((ref2 = data === null || data === void 0 ? void 0 : data.questions[currentIndex]) === null || ref2 === void 0 ? void 0 : ref2.type) === "single" && /*#__PURE__*/ (0,jsx_runtime.jsx)(SingleQuestionOptions, {
                                                page: currentIndex,
                                                onSelected: function(hasAnswer, answer) {
                                                    var ref;
                                                    setCurrentAnswer({
                                                        questionId: (ref = data === null || data === void 0 ? void 0 : data.questions[currentIndex]) === null || ref === void 0 ? void 0 : ref.id,
                                                        answer: answer,
                                                        isCorrect: isAnswerCorrect(data === null || data === void 0 ? void 0 : data.questions[currentIndex], answer)
                                                    });
                                                },
                                                showAnswers: showAnswers,
                                                options: (ref3 = data === null || data === void 0 ? void 0 : data.questions[currentIndex]) === null || ref3 === void 0 ? void 0 : ref3.answerOptions
                                            }),
                                            ((ref4 = data === null || data === void 0 ? void 0 : data.questions[currentIndex]) === null || ref4 === void 0 ? void 0 : ref4.type) === "multiple" && /*#__PURE__*/ (0,jsx_runtime.jsx)(MultipleQuestionOptions, {
                                                onSelected: function(hasAnswer, answer) {
                                                    var ref;
                                                    setCurrentAnswer({
                                                        questionId: (ref = data === null || data === void 0 ? void 0 : data.questions[currentIndex]) === null || ref === void 0 ? void 0 : ref.id,
                                                        answer: answer,
                                                        isCorrect: false
                                                    });
                                                },
                                                showAnswers: showAnswers,
                                                options: (ref5 = data === null || data === void 0 ? void 0 : data.questions[currentIndex]) === null || ref5 === void 0 ? void 0 : ref5.answerOptions
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat(isDesktop ? "mt-0 bg-white" : "fixed", " bottom-0 left-0 w-full"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "p-4 max-w-xl mx-auto",
                            children: [
                                !showAnswers && /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.z, {
                                    onClick: function() {
                                        setAnswers(function(old) {
                                            return (0,_to_consumable_array/* default */.Z)(old).concat([
                                                currentAnswer
                                            ]);
                                        });
                                        setShowAnswers(true);
                                    },
                                    color: "black",
                                    disabled: currentAnswer.questionId === null || currentAnswer.answer.length === 0,
                                    fullWidth: true,
                                    children: "Jawab"
                                }),
                                showAnswers && /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.z, {
                                    onClick: function() {
                                        var ref;
                                        return gotoNextQuestion(data === null || data === void 0 ? void 0 : (ref = data.questions) === null || ref === void 0 ? void 0 : ref.length);
                                    },
                                    color: "black",
                                    fullWidth: true,
                                    isLoading: isSubmittingForm,
                                    children: "Lanjut"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Quiz_QuizApp = (QuizApp);

// EXTERNAL MODULE: ./node_modules/@wartek-id/shimmer/dist/index.esm.js + 1 modules
var shimmer_dist_index_esm = __webpack_require__(28058);
;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/partials/Quiz/QuizPagePlaceholder.tsx




var QuizPagePlaceholder = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "p-4",
            role: "alert",
            "aria-busy": "true",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mb-4",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shimmer_dist_index_esm/* Shimmer */.q, {
                        height: 12,
                        noOfLines: 3,
                        className: "mb-1",
                        style: {
                            width: "100%"
                        }
                    })
                }),
                (0,_to_consumable_array/* default */.Z)(Array(4)).map(function(_, idx) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative p-4 w-full mx-auto mb-4 bg-white rounded shadow-card",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shimmer_dist_index_esm/* Shimmer */.q, {
                            height: 12,
                            noOfLines: 2,
                            className: "w-full mb-1",
                            style: {
                                width: "100%"
                            }
                        })
                    }, idx);
                })
            ]
        })
    });
};
/* harmony default export */ var Quiz_QuizPagePlaceholder = (QuizPagePlaceholder);

;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/pages/Quiz.tsx










var Quiz = function(param) {
    var _isDesktop = param.isDesktop, isDesktop = _isDesktop === void 0 ? false : _isDesktop;
    var ref = (0,router.useRouter)(), query = ref.query, isRouterReady = ref.isReady, back = ref.back;
    var ref1 = (0,react.useState)(false), isQueryNotComplete = ref1[0], setIsQueryNotComplete = ref1[1];
    var ref2 = (0,useAPIMateri/* useGetQuiz */.gN)(query.modul, query.id), isSuccess = ref2.isSuccess, isError = ref2.isError, data = ref2.data;
    (0,react.useEffect)(function() {
        if (isRouterReady && !query.modul) {
            setIsQueryNotComplete(true);
        }
    }, [
        query,
        isRouterReady
    ]);
    if (isQueryNotComplete) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(QueryNotCompleteError/* default */.Z, {});
    }
    if (isError) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyState/* EmptyState */.ub, {
            title: "Data gagal dimuat",
            description: "Ada kesalahan pada sistem. Silakan coba beberapa saat lagi.",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyState/* EmptyStateAction */.Px, {
                onClick: function() {
                    return window.location.reload();
                },
                children: "Muat Ulang"
            })
        });
    }
    if (isDesktop && isSuccess) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-row",
                    children: [
                        query.from && /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.J, {
                            as: "i",
                            className: "mr-2",
                            onClick: back,
                            children: "arrow_back"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.x, {
                                    className: "pb-1",
                                    children: "LATIHAN"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.x, {
                                    className: "pb-3",
                                    variant: "heading-lg",
                                    children: data.data.name
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "bg-white h-[80vh]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Quiz_QuizApp, {
                        materialId: query.id,
                        data: data.data,
                        isDesktop: isDesktop
                    })
                })
            ]
        });
    }
    if (isSuccess) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Quiz_QuizApp, {
            materialId: query.id,
            data: data.data
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Quiz_QuizPagePlaceholder, {});
};
/* harmony default export */ var pages_Quiz = (Quiz);

// EXTERNAL MODULE: ./components/Layout/Desktop/DesktopLayout.tsx
var DesktopLayout = __webpack_require__(72351);
// EXTERNAL MODULE: ./assets/icons/close.svg
var icons_close = __webpack_require__(17436);
;// CONCATENATED MODULE: ./pages/pelatihan-mandiri/quiz/[id].tsx
/* provided dependency */ var process = __webpack_require__(34155);








var QuizPage = function(props) {
    var isDesktopScreenSize = props.isDesktopScreenSize;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopLayout/* WithLayoutListener */.nc, {
        isDesktop: isDesktopScreenSize,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(pages_Quiz, {
            isDesktop: isDesktopScreenSize
        })
    });
};
var PageHeader = function() {
    var ref = (0,router.useRouter)(), query = ref.query, replace = ref.replace;
    var backUrl = "/".concat(process.env.NEXT_PUBLIC_TEMP_PELATIHAN_MANDIRI_PATH || "pelatihan-mandiri", "/modul/").concat(query.modul, "?") + (0,query_string/* stringify */.Pz)({
        topik: query.topik,
        topik_name: query.topik_name
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HeaderBar */.h_, {
        fixed: true,
        className: "z-10",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* HeaderBarLeftAction */.l8, {
                "data-testid": "back-button",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_close/* default */.Z, {
                    className: "stroke-current text-default"
                }),
                onClick: function() {
                    return replace(backUrl);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* HeaderBarTitle */.rF, {
                children: "Latihan Pemahaman"
            })
        ]
    });
};
QuizPage.layoutOpts = {
    hasHeader: true,
    className: "text-default",
    header: PageHeader,
    enableDesktopLayout: true
};
/* harmony default export */ var _id_ = (QuizPage);


/***/ }),

/***/ 54519:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);


/** Cautions
 *  If you use this hook directly on your page or on your template page
 *  please be aware that this hook may break your code since next.js sometimes trigger
 *  onRouteChange event when your route has params in it
 *  https://github.com/vercel/next.js/issues/10875
 *  To be safe, use this hook only after your page rendered (e.g wrap your page inside a component)
 */ function usePreventRouteChangeIf(shouldPreventRouteChange, onRouteChangePrevented) {
    var bindPopState = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var routeChangeStart = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(url) {
        if (router.asPath !== url && shouldPreventRouteChange) {
            router.events.emit("routeChangeError");
            /* tslint:disable-next-line */ onRouteChangePrevented && onRouteChangePrevented();
            // Following is a hack-ish solution to abort a Next.js route change
            // as there's currently no official API to do so
            // See https://github.com/zeit/next.js/issues/2476#issuecomment-573460710
            // eslint-disable-next-line no-throw-literal
            throw 'Route change to "'.concat(url, '" was aborted (this error can be safely ignored).');
        }
    }, [
        router,
        shouldPreventRouteChange,
        onRouteChangePrevented
    ]);
    var beforeUnload = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(e) {
        if (shouldPreventRouteChange) {
            e.preventDefault();
            onRouteChangePrevented && onRouteChangePrevented();
        }
    }, [
        shouldPreventRouteChange,
        onRouteChangePrevented
    ]);
    /**
   * Since beforeunload only support native browser dialog
   * so we bind the window event into simple function that return string
   * however on modern browser the string is not used on the dialog
   * reference: https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event
   */ var beforeUnloadNative = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(e) {
        if (shouldPreventRouteChange) {
            return e.returnValue = "Are you sure you want to leave this page?";
        }
    }, [
        shouldPreventRouteChange
    ]);
    var beforePopStateCallback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(param) {
        var url = param.url;
        if (router.asPath !== url && shouldPreventRouteChange && bindPopState) {
            window.history.pushState(null, "", url);
            router.replace(router, router.asPath, {
                shallow: true
            });
            onRouteChangePrevented && onRouteChangePrevented();
            return false;
        }
        return true;
    }, [
        bindPopState,
        onRouteChangePrevented,
        router,
        shouldPreventRouteChange
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        window.addEventListener("beforeunload", beforeUnloadNative);
        router.events.on("routeChangeStart", routeChangeStart);
        router.beforePopState(beforePopStateCallback);
        return function() {
            window.removeEventListener("beforeunload", beforeUnloadNative);
            router.events.off("routeChangeStart", routeChangeStart);
            router.beforePopState(function() {
                return true;
            });
        };
    }, [
        beforeUnloadNative,
        routeChangeStart,
        beforeUnload,
        router,
        beforePopStateCallback, 
    ]);
    return {
        // this should be called manually to remove listener ahead of time
        // of the react hook's callback cycle
        reset: function() {
            window.removeEventListener("beforeunload", beforeUnloadNative);
            router.events.off("routeChangeStart", routeChangeStart);
            router.beforePopState(function() {
                return true;
            });
        }
    };
}
/* harmony default export */ __webpack_exports__["Z"] = (usePreventRouteChangeIf);


/***/ }),

/***/ 40999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "fm": function() { return /* binding */ capitalizeFirstLetter; },
  "gQ": function() { return /* binding */ extractYTIdFromUrl; },
  "cZ": function() { return /* binding */ getUrlsFromText; },
  "hU": function() { return /* binding */ nl2br; },
  "lz": function() { return /* binding */ removeTagsStyleAttribute; },
  "ox": function() { return /* binding */ stripHTMLTags; },
  "mA": function() { return /* binding */ toKebabCase; }
});

// UNUSED EXPORTS: convertEmailToName, getNameFromFileUrl, oxfordConcat, removeQuery, truncateWordsByChar

;// CONCATENATED MODULE: ./utils/regex.ts
var URL_REGEX = /(https?:\/\/[^\s]+)/g;

;// CONCATENATED MODULE: ./utils/text.ts

function convertEmailToName(email) {
    var getEmailUsername = email.split("@")[0];
    return getEmailUsername.split(".").join(" ");
}
function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
function stripHTMLTags(originalString) {
    return !!originalString ? originalString.replace(/(<([^>]+)>)/gi, " ").trim() : originalString;
}
function truncateWordsByChar(str, maxLen) {
    var separator = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : " ";
    if (str.length <= maxLen) {
        return str;
    }
    return str.substr(0, str.lastIndexOf(separator, maxLen)) + "...";
}
function getUrlsFromText(text) {
    return text === null || text === void 0 ? void 0 : text.match(URL_REGEX);
}
function extractYTIdFromUrl(url) {
    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    var match = url.match(regExp);
    if (match && match[7].length === 11) {
        return match[7];
    }
    return "";
}
function removeTagsStyleAttribute(string) {
    var replacement = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    return string.replace(/(style=[",'])([a-zA-Z0-9:;.\s()\-,]*)([",'])/gi, replacement);
}
/**
 * Concatenates an array of strings into a string, delimited with commas (,) with inclusion of the 'Oxford comma'
 *
 * @example
 * // returns "Geometri"
 * oxfordConcat(['Geometri'])
 * @example
 * // returns "Geometri dan Aljabar"
 * oxfordConcat(['Geometri', 'Aljabar'])
 * @example
 * // returns "Geometri, Aljabar, dan Kalkulus"
 * oxfordConcat(['Geometri', 'Aljabar', 'Kalkulus'])
 *
 * @param {string[]} texts - Array of strings to process
 * @param {string} [conjunction=dan] - Conjunction to insert before the last item
 * @returns {string} The concatenated string
 */ function oxfordConcat(texts) {
    var conjunction = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "dan";
    var len = texts.length;
    if (len <= 0) return "";
    if (len < 2) return texts[0];
    if (len < 3) return texts.join(" ".concat(conjunction, " "));
    var result = texts.slice();
    result[len - 1] = "".concat(conjunction, " ").concat(texts[len - 1]);
    return result.join(", ");
}
/**
 * Removes queries and hashes from a URL
 * @param {string} url URL to be processed
 * @returns {string} Processed URL
 */ function removeQuery(url) {
    return url.split("?")[0].split("#")[0];
}
var toKebabCase = function(str) {
    return str && str.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g).map(function(x) {
        return x.toLowerCase();
    }).join("-");
};
/**
 * @param {string} str Input text
 * @param {boolean} replaceMode Use replace instead of insert
 * @param {boolean} isXhtml Use XHTML
 * @return {string} Filtered text
 */ function nl2br(str) {
    var replaceMode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, isXhtml = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    var breakTag = isXhtml ? "<br />" : "<br>";
    var replaceStr = replaceMode ? "$1" + breakTag : "$1" + breakTag + "$2";
    return (str + "").replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, replaceStr);
}
function getNameFromFileUrl(url, bucketName) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    // separator is defined as "=-". Also split on encoded string of "=-"
    var split = (ref8 = url === null || url === void 0 ? void 0 : (ref = url.split) === null || ref === void 0 ? void 0 : (ref1 = ref.call(url, "=-")) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.pop) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.call(ref1)) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.split) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.call(ref3, "%3D-")) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.pop) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.call(ref5)) === null || ref7 === void 0 ? void 0 : ref7.split("".concat(bucketName, "/"))) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.pop) === null || ref9 === void 0 ? void 0 : ref9.call(ref8);
    // decode URL encoded filename (convert %20 into space)
    var decodedFileName = decodeURIComponent(split);
    // eslint-disable-next-line no-extra-boolean-cast
    return !!split ? decodedFileName : url;
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1958,8189,1651,9291,1640,1529,6367,9774,2888,179], function() { return __webpack_exec__(61825); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);